import { _ as v } from "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import "./es.object.assign-7e79fd7b.js";
import { c as I } from "./index-8b07dec9.js";
import { forwardRef as b } from "react";
import "./es.array.filter-4e9c9996.js";
import "./es.array.concat-d1c9b847.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.entries-d2a19275.js";
import "./es.object.to-string-f55666a8.js";
import "./es.string.replace-f4cc3aea.js";
import "./es.array.is-array-7a29277f.js";
import "./web.dom-collections.for-each-3020ed11.js";
import { g as f } from "./getMetrics-953aa4f8.js";
import h, { css as g } from "styled-components";
import { Button as N } from "./button.js";
import { jsx as j } from "react/jsx-runtime";
import "./export-cdcbfb2b.js";
import "./object-keys-719a5561.js";
import "./array-iteration-759bfbfa.js";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./html-32ef1b46.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./iterate-13ada9e5.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./function-apply-4756dee6.js";
import "./array-method-is-strict-e5a3c878.js";
import "./es.object.keys-9d66766f.js";
import "@ucl/shared-component-foundations";
import "./combineRefs-c9ad2c39.js";
import "./web.set-timeout-72b6430f.js";
import "./environment-ddee5959.js";
import "./array-slice-79f93c56.js";
import "./validate-arguments-length-eb516e5b.js";
import "./es.array.some-0c761b6d.js";
import "./es.array.every-3d11adb5.js";
import "./useScroll.js";
import "./getTarget-19e0f923.js";
import "./useEventListener.js";
import "./isClient-2f5bedbd.js";
import "./useOverFlown.js";
import "./useResizeObserver.js";
import "./isApiSupported-66660265.js";
import "./useIsMounted.js";
import "./useSlots.js";
import "./createClass-57dcdeea.js";
import "./es.date.to-json-b76d522e.js";
import "./index-5d0f31c6.js";
import "./object-get-own-property-names-external-2f8b4cc4.js";
import "./an-instance-6efcfd6c.js";
import "./check-correctness-of-iteration-7d57c70c.js";
import "./inherit-if-required-f068457b.js";
import "./define-built-in-accessor-26bc7b69.js";
import "./set-species-5ede2ed0.js";
import "./es.string.iterator-5de8a61e.js";
import "@ucl/shared-icons";
var y = /* @__PURE__ */ h(N).withConfig({
  displayName: "iconButtonstyles__IconButton",
  componentId: "ej0rki-0"
})(["&.IconButton{", ";}"], function(r) {
  var o = r.theme.components.iconButton;
  return g(o.IconButton);
}), z = ["size", "variant", "color", "icon", "disabled", "className", "as", "children"], C = function(o, e) {
  var i = o.size, m = i === void 0 ? "medium" : i, p = o.variant, t = p === void 0 ? "primary" : p, n = o.color, a = o.icon, c = o.disabled, u = o.className, l = o.as;
  o.children;
  var d = v(o, z), B = f({
    label: "IconButton"
  }), s = n ?? (t === "ghost" ? "black" : "default");
  return /* @__PURE__ */ j(y, Object.assign({
    ref: e,
    forwardedAs: l,
    size: m,
    color: s,
    variant: t,
    rightIcon: a,
    icon: a,
    disabled: c,
    className: I(["IconButton", "IconButton--" + m, "IconButton--" + s, "IconButton--" + t, {
      "IconButton--disabled": c
    }, u])
  }, B, d));
}, Oo = /* @__PURE__ */ b(C);
export {
  Oo as IconButton
};
